<template>
  <div class="page">
    <div class="title">{{ data.infoTitle }}</div>
    <div class="content"
         v-html="data.infoDetail"></div>
  </div>
</template>

<script>
import { articleDetail } from '@/api/api'

export default {
  name: 'article-detail',
  data() {
    return {
      isShare: 0,
      id: null,
      data: {}
    }
  },
  created() {
    document.title = '隐私政策'
    this.id = this.$route.query.id
    this.isShare = this.$route.query.isShare || 0
    this.init()
  },
  methods: {
    init() {
      articleDetail({ type: 4 }).then(res => {
        res.result.infoDetail = this.formatRichText(res.result.infoDetail)
        this.data = res.result
        document.title = this.data.infoTitle || '隐私政策'
      })
    },
    formatRichText(detailText) {
      detailText = detailText.replace(/<img[^>]*>/gi, function (match) {
        return match.replace(/(style="(.*?)")|(width="(.*?)")|(height="(.*?)")/ig,
          'style="max-width:100%;height:auto;"')
      });
      return detailText;
    },
  }
}
</script>

<style scoped>
.title {
  padding: 10px 20px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #333;
}
.content {
  padding: 0 20px;
}
</style>